<script>
import Card from 'primevue/card';
// import LabelField from '../../generic/LabelField.vue';
    import Utils from '../../../common/Utils';

export default{
    props: [],
    components: {
        Card //, LabelField
    },
    data(){
        return {
            results: {
              initialMeasureRecalculated: {
                volumeCorrectionFactor: null,
                netVolume: null
              },
              weightedAverageDensity: {
                netVolume: null,
                averageDensity15: null,
                volumeCorrectionFactor: null,
                weightCorrectionFactor: null,
                roofVolume: null
              },
              finalLiquidMeasure: {
                shellTemperature: null,
                deltaTemperature: null,
                waterVolume: null,
                thermalExpansionFactor: null,
                shellVolume: null,
                roofVolume: null,
                grossVolume: null,
                sulfurPercentage: null,
                netVolume: null,
                weightCorrectionFactor: null
              },
              netFinalMeasure: {
                waterAndSedimentsVolumePercentage: null,
                waterAndSedimentsCorrectionFactor: null,
                introducedVolume: null,
                waterAndSedimentsIntroducedVolume: null,
                volume15: null,
                introducedQuantity: null,
                stockWeight: null,
                removableVolume: null,
                removableWeight: null
              }
            }
        }
    },
    methods: {
      loadResults(data){
        if(data){
          this.results = data;
        }
      },
      getResults(){
        return this.results;
      }
    },
    computed: {
        utils(){
            return Utils;
        },
    }
};
</script>

<template>
  <div class="grid">
    <div class="col-12 lg:col-4">
      <Card >
          <template #subtitle>
              {{$t('calculatorDischargeDevelopment.initialMeasureRecalculatedTitle')}}
          </template>
          <template #content>
              <div class="grid formgrid" >
                  <div :class="{'col-12 field': true}">
                    <!-- <LabelField :value="utils.formatDecimal(results.initialMeasureRecalculated.volumeCorrectionFactor,4)" :label="$t('calculatorDischargeDevelopment.coeffFX54')"/> -->
                    <label>{{$t('calculatorDischargeDevelopment.coeffFX54')}}</label>
                    <InputNumber class="w-full p-inputtext-sm" readonly  v-model="results.initialMeasureRecalculated.volumeCorrectionFactor" :minFractionDigits="4" :maxFractionDigits="4" />
                  </div>    
                  <div :class="{'col-12 field': true}">
                    <!-- <LabelField :value="utils.formatInteger(results.initialMeasureRecalculated.netVolume)" :label="$t('calculatorDischargeDevelopment.volNetto')"/> -->
                    <label>{{$t('calculatorDischargeDevelopment.volNetto')}}</label>
                    <InputNumber class="w-full p-inputtext-sm" readonly  v-model="results.initialMeasureRecalculated.netVolume" :minFractionDigits="0" :maxFractionDigits="0" />
                  </div>
              </div>
          </template>
      </Card>
      <Card class="my-2">
          <template #subtitle>
              {{$t('calculatorDischargeDevelopment.weightedAverageDensityTitle')}}
          </template>
          <template #content>
              <div class="grid formgrid" >  
                  <div :class="{'col-12 field': true}">
                    <!-- <LabelField :value="utils.formatInteger(results.weightedAverageDensity.netVolume)" :label="$t('calculatorDischargeDevelopment.volLordoTetto')"/> -->
                    <label>{{$t('calculatorDischargeDevelopment.volLordoTetto')}}</label>
                    <InputNumber class="w-full p-inputtext-sm" readonly  v-model="results.weightedAverageDensity.netVolume" :minFractionDigits="0" :maxFractionDigits="0" />
                  </div>
                  <div :class="{'col-12 field': true}">
                    <!-- <LabelField :value="utils.formatDecimal(results.weightedAverageDensity.averageDensity15,5)" :label="$t('calculatorDischargeDevelopment.densityMed')"/> -->
                    <label>{{$t('calculatorDischargeDevelopment.densityMed')}}</label>
                    <InputNumber class="w-full p-inputtext-sm" readonly  v-model="results.weightedAverageDensity.averageDensity15" :minFractionDigits="5" :maxFractionDigits="5" />
                  </div>  
                  <div :class="{'col-12 field': true}">
                    <!-- <LabelField :value="utils.formatDecimal(results.weightedAverageDensity.volumeCorrectionFactor,5)" :label="$t('calculatorDischargeDevelopment.coeffFX54')"/> -->
                    <label>{{$t('calculatorDischargeDevelopment.coeffFX54')}}</label>
                    <InputNumber class="w-full p-inputtext-sm" readonly  v-model="results.weightedAverageDensity.volumeCorrectionFactor" :minFractionDigits="5" :maxFractionDigits="5" />
                  </div>  
                  <div :class="{'col-12 field': true}">
                    <!-- <LabelField :value="utils.formatDecimal(results.weightedAverageDensity.weightCorrectionFactor,4)" :label="$t('calculatorDischargeDevelopment.coeffFX56')"/> -->
                    <label>{{$t('calculatorDischargeDevelopment.coeffFX56')}}</label>
                    <InputNumber class="w-full p-inputtext-sm" readonly  v-model="results.weightedAverageDensity.weightCorrectionFactor" :minFractionDigits="4" :maxFractionDigits="4" />
                  </div>  
                  <div :class="{'col-12 field': true}">
                    <!-- <LabelField :value="utils.formatInteger(results.weightedAverageDensity.roofVolume)" :label="$t('calculatorDischargeDevelopment.volTetto')"/> -->
                    <label>{{$t('calculatorDischargeDevelopment.volTetto')}}</label>
                    <InputNumber class="w-full p-inputtext-sm" readonly  v-model="results.weightedAverageDensity.roofVolume" :minFractionDigits="0" :maxFractionDigits="0" />
                  </div>  
              </div>
          </template>
      </Card>
    </div>
    <div class="col-12 lg:col-4">
      <Card>
        <template #subtitle>
            {{$t('calculatorDischargeDevelopment.finalLiquidMeasureTitle')}}
        </template>
        <template #content>
            <div class="grid formgrid" >
                <div :class="{'col-12 field': true}">
                  <!-- <LabelField :value="utils.formatDecimal(results.finalLiquidMeasure.shellTemperature,2)" :label="$t('calculatorDischargeDevelopment.tempMant')"/> -->
                    <label>{{$t('calculatorDischargeDevelopment.tempMant')}}</label>
                    <InputNumber class="w-full p-inputtext-sm" readonly  v-model="results.finalLiquidMeasure.shellTemperature" :minFractionDigits="2" :maxFractionDigits="2" />
                </div>    
                <div :class="{'col-12 field': true}">
                  <!-- <LabelField :value="utils.formatDecimal(results.finalLiquidMeasure.deltaTemperature,2)" :label="$t('calculatorDischargeDevelopment.deltaTemp')"/> -->
                    <label>{{$t('calculatorDischargeDevelopment.deltaTemp')}}</label>
                    <InputNumber class="w-full p-inputtext-sm" readonly  v-model="results.finalLiquidMeasure.deltaTemperature" :minFractionDigits="2" :maxFractionDigits="2" />
                </div>    
                <div :class="{'col-12 field': true}">
                  <!-- <LabelField :value="utils.formatInteger(results.finalLiquidMeasure.waterVolume)" :label="$t('calculatorDischargeDevelopment.volAcqua')"/> -->
                    <label>{{$t('calculatorDischargeDevelopment.volAcqua')}}</label>
                    <InputNumber class="w-full p-inputtext-sm" readonly  v-model="results.finalLiquidMeasure.waterVolume" :minFractionDigits="0" :maxFractionDigits="0" />
                </div>    
                <div :class="{'col-12 field': true}">
                  <!-- <LabelField :value="utils.formatDecimal(results.finalLiquidMeasure.thermalExpansionFactor,5)" :label="$t('calculatorDischargeDevelopment.coeffDilatTerm')"/> -->
                    <label>{{$t('calculatorDischargeDevelopment.coeffDilatTerm')}}</label>
                    <InputNumber class="w-full p-inputtext-sm" readonly  v-model="results.finalLiquidMeasure.thermalExpansionFactor" :minFractionDigits="5" :maxFractionDigits="5" />
                </div>   
                <div :class="{'col-12 field': true}">
                  <!-- <LabelField :value="utils.formatInteger(results.finalLiquidMeasure.grossVolumeWithoutWater)" :label="$t('calculatorDischargeDevelopment.volLordoAcqua')"/> -->
                    <label>{{$t('calculatorDischargeDevelopment.volLordoAcqua')}}</label>
                    <InputNumber class="w-full p-inputtext-sm" readonly  v-model="results.finalLiquidMeasure.grossVolumeWithoutWater" :minFractionDigits="0" :maxFractionDigits="0" />
                </div>    
                <div :class="{'col-12 field': true}">
                  <!-- <LabelField :value="utils.formatInteger(results.finalLiquidMeasure.grossVolume)" :label="$t('calculatorDischargeDevelopment.volLordo')"/> -->
                    <label>{{$t('calculatorDischargeDevelopment.volLordo')}}</label>
                    <InputNumber class="w-full p-inputtext-sm" readonly  v-model="results.finalLiquidMeasure.grossVolume" :minFractionDigits="0" :maxFractionDigits="0" />
                </div>    
                <div :class="{'col-12 field': true}">
                  <!-- <LabelField :value="utils.formatDecimal(results.finalLiquidMeasure.weightCorrectionFactor,4)" :label="$t('calculatorDischargeDevelopment.coeffFX54')"/> -->
                    <label>{{$t('calculatorDischargeDevelopment.coeffFX54')}}</label>
                    <InputNumber class="w-full p-inputtext-sm" readonly  v-model="results.finalLiquidMeasure.weightCorrectionFactor" :minFractionDigits="4" :maxFractionDigits="4" />
                </div>    
                <div :class="{'col-12 field': true}">
                  <!-- <LabelField :value="utils.formatInteger(results.finalLiquidMeasure.roofVolume)" :label="$t('calculatorDischargeDevelopment.volTetto')"/> -->
                    <label>{{$t('calculatorDischargeDevelopment.volTetto')}}</label>
                    <InputNumber class="w-full p-inputtext-sm" readonly  v-model="results.finalLiquidMeasure.roofVolume" :minFractionDigits="0" :maxFractionDigits="0" />
                </div>    
                <div :class="{'col-12 field': true}">
                  <!-- <LabelField :value="utils.formatInteger(results.finalLiquidMeasure.netVolume)" :label="$t('calculatorDischargeDevelopment.volLordoTetto')"/> -->
                    <label>{{$t('calculatorDischargeDevelopment.volLordoTetto')}}</label>
                    <InputNumber class="w-full p-inputtext-sm" readonly  v-model="results.finalLiquidMeasure.netVolume" :minFractionDigits="0" :maxFractionDigits="0" />
                </div>    
                <div :class="{'col-12 field': true}">
                  <!-- <LabelField :value="utils.formatInteger(results.finalLiquidMeasure.sulfurPercentage)" :label="$t('tankOperations.sulfurPercentage')"/> -->
                    <label>{{$t('tankOperations.sulfurPercentage')}}</label>
                    <InputNumber class="w-full p-inputtext-sm" readonly  v-model="results.finalLiquidMeasure.sulfurPercentage" :minFractionDigits="0" :maxFractionDigits="0" />
                </div>    
                <div :class="{'col-12 field': true}">
                  <!-- <LabelField :value="utils.formatInteger(results.finalLiquidMeasure.movedVolume)" :label="$t('calculatorDischargeDevelopment.volIntr')"/> -->
                    <label>{{$t('calculatorDischargeDevelopment.volIntr')}}</label>
                    <InputNumber class="w-full p-inputtext-sm" readonly  v-model="results.finalLiquidMeasure.movedVolume" :minFractionDigits="0" :maxFractionDigits="0" />
                </div>    
            </div>
        </template>
      </Card>
    </div>
    <div class="col-12 lg:col-4">
      <Card>
        <template #subtitle>
            {{$t('calculatorDischargeDevelopment.netFinalMeasureTitle')}}
        </template>
        <template #content>
            <div class="grid formgrid" >
                <div :class="{'col-12 field': true}">
                  <!-- <LabelField :value="utils.formatInteger(results.netFinalMeasure.waterAndSedimentsVolumePercentage)" :label="$t('calculatorDischargeDevelopment.SW')"/> -->
                    <label>{{$t('calculatorDischargeDevelopment.SW')}}</label>
                    <InputNumber class="w-full p-inputtext-sm" readonly  v-model="results.netFinalMeasure.waterAndSedimentsVolumePercentage" :minFractionDigits="3" :maxFractionDigits="3" />
                </div>    
                <div :class="{'col-12 field': true}">
                  <!-- <LabelField :value="utils.formatInteger(results.netFinalMeasure.waterAndSedimentsCorrectionFactor)" :label="$t('calculatorDischargeDevelopment.coeffsSW')"/> -->
                    <label>{{$t('calculatorDischargeDevelopment.coeffsSW')}}</label>
                    <InputNumber class="w-full p-inputtext-sm" readonly  v-model="results.netFinalMeasure.waterAndSedimentsCorrectionFactor" :minFractionDigits="5" :maxFractionDigits="5" />
                </div>    
                <div :class="{'col-12 field': true}">
                  <!-- <LabelField :value="utils.formatInteger(results.netFinalMeasure.introducedVolume)" :label="$t('calculatorDischargeDevelopment.volIntr')"/> -->
                    <label>{{$t('calculatorDischargeDevelopment.volIntr')}}</label>
                    <InputNumber class="w-full p-inputtext-sm" readonly  v-model="results.netFinalMeasure.introducedVolume" :minFractionDigits="0" :maxFractionDigits="0" />
                </div>    
                <div :class="{'col-12 field': true}">
                  <!-- <LabelField :value="utils.formatInteger(results.netFinalMeasure.waterAndSedimentsIntroducedVolume)" :label="$t('calculatorDischargeDevelopment.SWLt')"/> -->
                    <label>{{$t('calculatorDischargeDevelopment.SWLt')}}</label>
                    <InputNumber class="w-full p-inputtext-sm" readonly  v-model="results.netFinalMeasure.waterAndSedimentsIntroducedVolume" :minFractionDigits="0" :maxFractionDigits="0" />
                </div>    
                <div :class="{'col-12 field': true}">
                  <!-- <LabelField :value="utils.formatInteger(results.netFinalMeasure.volume15)" :label="$t('calculatorDischargeDevelopment.vol15')"/> -->
                    <label>{{$t('calculatorDischargeDevelopment.vol15')}}</label>
                    <InputNumber class="w-full p-inputtext-sm" readonly  v-model="results.netFinalMeasure.volume15" :minFractionDigits="0" :maxFractionDigits="0" />
                </div>    
                <div :class="{'col-12 field': true}">
                  <!-- <LabelField :value="utils.formatInteger(results.netFinalMeasure.introducedQuantity)" :label="$t('calculatorDischargeDevelopment.Qta')"/> -->
                    <label>{{$t('calculatorDischargeDevelopment.Qta')}}</label>
                    <InputNumber class="w-full p-inputtext-sm" readonly  v-model="results.netFinalMeasure.introducedQuantity" :minFractionDigits="0" :maxFractionDigits="0" />
                </div>    
                <div :class="{'col-12 field': true}">
                  <!-- <LabelField :value="utils.formatInteger(results.netFinalMeasure.stockWeight)" :label="$t('calculatorDischargeDevelopment.pesoGiacenza')"/> -->
                    <label>{{$t('calculatorDischargeDevelopment.pesoGiacenza')}}</label>
                    <InputNumber class="w-full p-inputtext-sm" readonly  v-model="results.netFinalMeasure.stockWeight" :minFractionDigits="0" :maxFractionDigits="0" />
                </div>    
                <div :class="{'col-12 field': true}">
                  <!-- <LabelField :value="utils.formatInteger(results.netFinalMeasure.removableVolume)" :label="$t('calculatorDischargeDevelopment.volEstraib')"/> -->
                    <label>{{$t('calculatorDischargeDevelopment.volEstraib')}}</label>
                    <InputNumber class="w-full p-inputtext-sm" readonly  v-model="results.netFinalMeasure.removableVolume" :minFractionDigits="0" :maxFractionDigits="0" />
                </div>    
                <div :class="{'col-12 field': true}">
                  <!-- <LabelField :value="utils.formatInteger(results.netFinalMeasure.removableWeight)" :label="$t('calculatorDischargeDevelopment.pesoEstraib')"/> -->
                    <label>{{$t('calculatorDischargeDevelopment.pesoEstraib')}}</label>
                    <InputNumber class="w-full p-inputtext-sm" readonly  v-model="results.netFinalMeasure.removableWeight" :minFractionDigits="0" :maxFractionDigits="0" />
                </div>    
            </div>
        </template>
      </Card>
    </div>
  </div>
</template>